export default {
  /** 原料价格分页查询 */
  LIST_PRODUCTPRICE_BY_PAGE: '/produce/productPrice/queryPdPeriodPage',
  /** 原料价格批量导入 */
  LIST_PRODUCTPRICE_IMPORT: '/produce/productPrice/importProductPrice',
  /** 原料价格导出 */
  LIST_PRODUCTPRICE_EXPORT: '/produce/productPrice/exportExcel',
  /** 原料价格确认按钮 */
  LIST_PRODUCTPRICE_CONFIRM: '/produce/productPrice/confirm',
};
